import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PermissionService } from '../_services';

@Injectable({
  providedIn: 'root'
})
export class SelfServiceGuard implements CanActivate {

  constructor(private router: Router, private permissionService: PermissionService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser) {
      return of(this.router.createUrlTree(['/login']));
    }

    // JS-1920 (2026-10-16): any-of-6 + legacy fallback — gates /client/self-service/*.
    return this.permissionService.canAccessSelfServiceModule().pipe(
      map((allowed) => {
        if (allowed) {
          return true;
        }
        const fallback = currentUser.role && currentUser.role.includes('client')
          ? '/client-dashboard'
          : '/project';
        return this.router.createUrlTree([fallback]);
      }),
      catchError(() => of(this.router.createUrlTree(['/login'])))
    );
  }
}
